import React, { Children } from 'react';
import { motion } from 'framer-motion';
const benefits = ['Reducir el tiempo de pantallas sin gritos', 'Establecer límites claros y sostenibles', 'Recuperar el respeto sin perder el vínculo', 'Mejorar la atención y el descanso de tu hijo', 'Crear rutinas familiares saludables', 'Evitar discusiones diarias', 'Proponer alternativas reales a las pantallas', 'Comunicar reglas sin culpa', 'Aumentar la calma en casa', 'Sentirte nuevamente un padre/madre seguro y firme'];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 15
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.4,
      ease: 'easeOut'
    }
  }
};
export function Benefits() {
  return <section className="w-full bg-mint-light py-16 px-6" data-id="element-9">
      <div className="max-w-2xl mx-auto text-center" data-id="element-10">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5
      }} className="font-playfair text-2xl md:text-3xl font-semibold text-dark-text mb-10" data-id="element-11">
          Con esta guía práctica vas a lograr:
        </motion.h2>

        <motion.ol variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="space-y-4 text-left max-w-lg mx-auto" data-id="element-12">
          {benefits.map((benefit, index) => <motion.li key={index} variants={itemVariants} className="font-lato text-base md:text-lg text-dark-text flex items-start gap-3" data-id="element-13">
              <span className="font-semibold text-mint min-w-[28px]" data-id="element-14">
                {index + 1}.
              </span>
              <span data-id="element-15">{benefit}</span>
            </motion.li>)}
        </motion.ol>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.8
      }} className="font-playfair text-xl md:text-2xl font-bold text-dark-text mt-12" data-id="element-16">
          Menos pantallas. Más conexión real.
        </motion.p>
      </div>
    </section>;
}